export interface EmailTemplate {
  id: string;
  name: string;
  codeName: string;
  description?: string | null;
  category: string;
  subject: string;
  bodyHtml: string;
  isActive: boolean;
  isSystem: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PagedEmailTemplateResult {
  items: EmailTemplate[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface EmailTemplateFilter {
  category?: string;
  isActive?: boolean;
  search?: string;
  page?: number;
  pageSize?: number;
}

export interface UpsertEmailTemplateRequest {
  name: string;
  codeName: string;
  description?: string | null;
  category: string;
  subject: string;
  bodyHtml: string;
  isActive: boolean;
}

export interface EmailTemplateMacro {
  key: string;
  label: string;
  description: string;
  group: string;
}

export interface EmailTemplateMacroSample {
  name: string;
}

export interface EmailTemplateTestPreview {
  template: EmailTemplate;
  macros: EmailTemplateMacroSample[];
  renderedSubject: string;
  renderedBodyHtml: string;
}

export interface SendEmailTemplateTestPayload {
  to: string;
  context?: Record<string, string>;
}

export interface SendEmailTemplateTestResult {
  enqueued: boolean;
  emailId: string;
}

export const EMAIL_TEMPLATE_CATEGORIES: string[] = [
  'Notificações',
  'Suporte',
  'Atendimento',
  'Transacionais',
  'Assinaturas',
  'Workflow',
  'Formulários',
  'Sistema',
];
